import type { SearchResultFragment } from "@qw/graphql";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandLoading,
  Loading,
  SearchProvider,
  Separator,
  useSearch,
} from "@qw/ui";

interface LinkInsuredSearchProps {
  autoFocus?: boolean;
  onSelect: (insured: SearchResultFragment) => void;
}

export const LinkInsuredSearch = ({ autoFocus = true, onSelect }: LinkInsuredSearchProps) => (
  <SearchProvider>
    <LinkInsuredCommand autoFocus={autoFocus} onSelect={onSelect} />
  </SearchProvider>
);

const LinkInsuredCommand = ({ autoFocus = true, onSelect }: LinkInsuredSearchProps) => {
  const { searchTerm, setSearchTerm, loading, insureds } = useSearch();

  return (
    <Command className="-m-1">
      <CommandInput
        autoFocus={autoFocus}
        className="text-xs"
        placeholder="Search insureds..."
        value={searchTerm}
        onValueChange={setSearchTerm}
      />

      {loading && !insureds?.length && (
        <>
          <Separator />
          <CommandLoading>
            <Loading label={<>Loading options&hellip;</>} />
          </CommandLoading>
        </>
      )}

      {!!insureds?.length && (
        <>
          <Separator />
          <CommandList className="max-h-60">
            {!loading && <CommandEmpty>No results found.</CommandEmpty>}

            <CommandGroup>
              {insureds?.map((insured) => (
                <CommandItem value={insured.insuredName} key={insured.insuredId} onSelect={() => onSelect(insured)}>
                  <span className="text-xs">{insured.insuredName}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </>
      )}
    </Command>
  );
};
